import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import { Section } from '@/components/shared';
import { Trans, useTranslation } from 'react-i18next';
import { ROUTE_PATHS } from '@/constants';
import { MbeInfo } from '@/components/icons';

export const ExpiredQuote = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Section
      containerProps={{ py: 0, gap: { base: 8, md: 16 } }}
      headingProps={{ mt: 0 }}
      id="expired-quote-message"
    >
      <Flex
        alignItems="center"
        direction="column"
        gap={6}
        px={{ base: 8, md: 16, xl: 44 }}
        py={{ base: 10, md: 24 }}
      >
        <Icon as={MbeInfo} color="brand.red.light" h={14} w={14} />
        <Text fontSize={{ base: 'h1.base', md: 'h1.mb' }} fontWeight="bold" textAlign="center">
          {t('COMMUNICATIONS.EXPIRED_QUOTE.TITLE')}
        </Text>
        <Text fontSize={{ base: 'p.base', md: 'p.mb' }} textAlign="center">
          <Trans i18nKey={'COMMUNICATIONS.EXPIRED_QUOTE.MESSAGE'} />
        </Text>
        <Button as="a" href={`/${ROUTE_PATHS.quote}`} mt={8} variant="mbeSecondary">
          {t('COMMUNICATIONS.EXPIRED_QUOTE.CTA')}
        </Button>
      </Flex>
    </Section>
  );
};
